import { useState, useCallback } from 'react';
import { httpCheckoutAPI } from 'V2/Services/httpCheckoutAPI';

interface UsePaymentSessionResult {
  isReady: boolean;
  isLoading: boolean;
  error: string | null;
  initialize: () => Promise<void>;
}

export const usePaymentSession = (appId: string): UsePaymentSessionResult => {
  const [isReady, setIsReady] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const initialize = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      await httpCheckoutAPI.get({
        url: `/bindapi/insurance_applications/${appId}/tokens/iframe`,
      });
      setIsReady(true);
    } catch {
      setError('Unable to load payment form. Please refresh and try again.');
    } finally {
      setIsLoading(false);
    }
  }, [appId]);

  return { isReady, isLoading, error, initialize };
};
